import helper from '../helper'

export const serviceTopUp = {
  get: () => helper.get('api/v1/transactions/prices'),
  post: (token, role) => helper.post('api/v1/transactions/topup', { role }, token),
  getTransaction: (token, params) => helper.get('api/v1/transactions', token, params)
}
